import { render, staticRenderFns } from "./hzdx.vue?vue&type=template&id=9ba9b98a&scoped=true"
import script from "./hzdx.vue?vue&type=script&lang=js"
export * from "./hzdx.vue?vue&type=script&lang=js"
import style0 from "./hzdx.vue?vue&type=style&index=0&id=9ba9b98a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba9b98a",
  null
  
)

export default component.exports